module.exports = __webpack_public_path__ + "media/pdf/AGB_Bankberater_Juli22-0852c2b9a2db35f35cd10f555ada872d.pdf";